export class Cpf {
  constructor(private readonly cpf: string) {}

  format() {
    const digitosCpf = this.cpf.replace(/\D/g, '')
    if (digitosCpf.length !== 11) throw new Error('Invalid CPF')
    const cpfMask = /^(\d{3})(\d{3})(\d{3})(\d{2})$/
    return digitosCpf.replace(cpfMask, '$1.$2.$3-$4')
  }

  validate() {
    const digitosCpf = this.cpf.replace(/\D/g, '')
    const digitosIguais = /^(\d)\1{10}$/
    if (digitosCpf.toString().length !== 11 || digitosIguais.test(digitosCpf)) return false
    let result = true
    ;[9, 10].forEach((posicaoDigitoVerificador: number) => {
      let soma = 0
      let digitoVerificador: number

      Array.from(digitosCpf)
        .splice(0, posicaoDigitoVerificador)
        .forEach((digito: string, i: number) => {
          soma += parseInt(digito, 10) * (posicaoDigitoVerificador + 2 - (i + 1))
        })

      digitoVerificador = soma % 11
      digitoVerificador = digitoVerificador < 2 ? 0 : 11 - digitoVerificador
      if (digitoVerificador.toString() !== digitosCpf.substring(posicaoDigitoVerificador, posicaoDigitoVerificador + 1))
        result = false
    })
    return result
  }
}
